<template>
  <div class="time-selector">
    <div v-if="editMode">
      <el-time-select
        ref="time_selector"
        class="inline-time-select"
        v-bind:value="selectedTime"
        v-on:input="onInput"
        :placeholder="placeholder"
        :size="size"
        :picker-options="timePickerOptions"
        @change="onUpdate"
        @blur="onUnfocus">
      </el-time-select>
      <el-button
        v-if="show_confirm_button"
        size="mini"
        type="success"
        @click="onSave"
        style="position: relative">ok</el-button>
    </div>
    <template v-if="!editMode">
      <a href="#" @click.prevent="onStartEditMode" :style="textColor">
        {{ selectedTime ? selectedTimeFormatted : 'not set' }}
      </a>
    </template>
  </div>
</template>

<script>
import moment from '@/moment-gp'

/* This component can not handle user timezone... which is probably fine,
   but wherever timeSelectorInline is used, the results still might need
   conversion. */

const timePickerOptionsDefault = {
  start: '00:00',
  step:  '00:30',
  end:   '24:00'
};

export default {
  props: {
    show_confirm_button: {
      default: false
    },
    placeholder: {
      default: 'Select time'
    },
    value: {
      default: []
    },
    size: {
      default: 'medium'
    },
    timePickerOptions: {
      default: () => (timePickerOptionsDefault)
    },
    color: {
      type: String,
      default: '#000000'
    }
  },
  watch: {
    value(v) {
      this.selectedTime = v;
    }
  },
  data: () => ({
    editMode: false,
    selectedTime: null,
  }),
  mounted() {
    this.selectedTime = this.value;
  },
  computed: {
    textColor() {
      return { 'color': this.color }
    },
    selectedTimeFormatted() {
      return this.$options.filters.shortTime( moment( this.selectedTime, 'HH:mm' ) )
    },
  },
  methods: {
    onStartEditMode() {
      this.editMode = !this.editMode;
      this.$nextTick(() => {
        this.$refs.time_selector.focus();
      })
    },

    onUpdate() {
      // this.$emit('input', this.selectedTime);  <<<< WORKAROUND
      if ( !this.show_confirm_button ) {
        this.onSave();
      }
    },

    onInput($event) {
      this.selectedTime = $event;
    },

    onSave() {
      this.editMode = false;
      this.$emit('save', this.selectedTime)
    },

    onUnfocus() {
      this.editMode = false;
    }
  }
}
</script>

<style>
.time-selector .inline-time-select {
  display: inline-block;
  margin: 0 0.1em;
  width: 8em;
}
.time-selector {
  display: inline-block;
  position: relative;
}
.time-selector .el-checkbox-button {
  margin-bottom: 0;
}
.time-selector-helper {
  font-size: 9pt;
}
</style>
